/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InfringementEvent } from './InfringementEvent';
import {
    InfringementEventFromJSON,
    InfringementEventFromJSONTyped,
    InfringementEventToJSON,
    InfringementEventToJSONTyped,
} from './InfringementEvent';

/**
 * 
 * @export
 * @interface PaginatedInfringementEventList
 */
export interface PaginatedInfringementEventList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedInfringementEventList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedInfringementEventList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedInfringementEventList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<InfringementEvent>}
     * @memberof PaginatedInfringementEventList
     */
    results: Array<InfringementEvent>;
}

/**
 * Check if a given object implements the PaginatedInfringementEventList interface.
 */
export function instanceOfPaginatedInfringementEventList(value: object): value is PaginatedInfringementEventList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedInfringementEventListFromJSON(json: any): PaginatedInfringementEventList {
    return PaginatedInfringementEventListFromJSONTyped(json, false);
}

export function PaginatedInfringementEventListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedInfringementEventList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(InfringementEventFromJSON)),
    };
}

  export function PaginatedInfringementEventListToJSON(json: any): PaginatedInfringementEventList {
      return PaginatedInfringementEventListToJSONTyped(json, false);
  }

  export function PaginatedInfringementEventListToJSONTyped(value?: PaginatedInfringementEventList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(InfringementEventToJSON)),
    };
}

